import { copy } from 'ionicons/icons';
import { useMemo } from 'react';
import { getLocalizedText } from '../../../../../i18n/i18n.utils';
import { useClipboardContext } from '../../hook/clipboard.hooks';
import { useFlowServices } from '../../hook/flow-service.hooks';
import { ApplicationClipboardPath, FlowItem } from '../../model/flow.types';
import { TeachDetailOption } from './teach.types';

interface AdditionalTeachOptionsArgs {
  onAdd: (flowItems: FlowItem[]) => void;
}

export const useAdditionalTeachOptions = (
  args: AdditionalTeachOptionsArgs
): TeachDetailOption[] => {
  const { onAdd } = args;
  const { paste } = useClipboardContext();
  const { flowAnalyticService, flowItemService } = useFlowServices();

  const itemsToPaste =
    paste<FlowItem[]>(ApplicationClipboardPath.FLOW_ITEMS) ?? [];

  const pasteLabel = useMemo(() => {
    let label = getLocalizedText('common:paste_items');
    if (itemsToPaste.length > 0) {
      label += ` (${itemsToPaste.length})`;
    }
    return label;
  }, [itemsToPaste.length]);

  const additionalOpts: TeachDetailOption[] = [];

  additionalOpts.push({
    optionId: 'paste',
    icon: copy,
    description: pasteLabel,
    onAdd: () => {
      if (itemsToPaste.length > 0) {
        // Delegating ID resetting to handlePasteFlowItems to ensure consistency across pasted items.
        const items = flowItemService.handlePasteFlowItems(itemsToPaste);

        onAdd(items);
        flowAnalyticService.trackPasteFlowItems();
      }
    },
    chipLabel: getLocalizedText('common:paste'),
    isDisabled: itemsToPaste.length === 0,
  });

  return additionalOpts;
};
